// ProtectedRoute — gates a subtree behind auth + optional role check.
//
// Behavior:
//   • While the bootstrap /me call is in-flight → renders a subtle
//     skeleton so we don't flash the login screen on refresh.
//   • Unauthenticated → redirect to `/admin/login` and remember the
//     originally-requested URL for post-login return.
//   • Authenticated but role not allowed → redirect to `/` (public).
//   • Otherwise → render children.

import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ roles }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div data-testid="protected-route-bootstrapping" className="grid min-h-screen place-items-center bg-surface-50">
        <div className="flex items-center gap-3 text-sm text-ink-500">
          <span className="inline-block h-4 w-4 animate-pulse rounded-full bg-fursa-500/60" aria-hidden />
          جاري التحقّق من الجلسة…
        </div>
      </div>
    );
  }

  if (!user) {
    // Preserve the originally-requested URL so we can bounce the user
    // back after successful sign-in.
    return (
      <Navigate
        to="/admin/login"
        state={{ from: `${location.pathname}${location.search}${location.hash}` }}
        replace
      />
    );
  }

  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
